<div style="display:grid; gap:12px;">
  <h2 mat-dialog-title class="dialog-icon-title">
    <mat-icon>security</mat-icon>
    <span i18n="@@section.signInMethods.securityVerification">Security verification</span>
  </h2>

  <div mat-dialog-content>
    <p i18n="@@section.signInMethods.reauth.sso.message">
      To continue, please confirm it's really you by signing into your linked {{ data.providerName }} account.
    </p>
  </div>

  <div mat-dialog-actions class="dialog-buttons">
    <button mat-stroked-button (click)="onCancel()" i18n="@@common.cancel">
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()" i18n="@@section.signInMethods.reauth.sso.continue">
      Continue with {{ data.providerName }}
    </button>
  </div>
</div>
